import React, { Fragment, useState } from 'react'

const Toggle = props => {
  const { Handle, children, handle } = props
  if (handle) throw new Error("Handle prop should start with a capital 'H'.")
  const [open, setOpen] = useState(props.open || false)

  return (
    <Fragment>
      <Handle onClick={() => setOpen(!open)} open={open} />
      {open ? children : null}
    </Fragment>
  )
}

export default Toggle
